import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

/**
 * Componente para el modal de vista previa de archivos multimedia
 *
 * @param {Object} props - Propiedades del componente
 * @param {Boolean} props.show - Estado del modal
 * @param {Function} props.handleClose - Función para cerrar el modal
 * @param {String} props.type - Tipo de archivo
 * @param {String} props.src - URL del archivo
 * @returns {JSX.Element} Componente de React
 */
const ModalPreviewMedia = ({ show, handleClose, type, src }) => {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);

  const handleZoomChange = (newScale) => {
    setScale(newScale);
  };

  const handlePanChange = (newPosition) => {
    setPosition(newPosition);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <div className="d-flex justify-content-center">
          {src && type === "image" ? (
            <TransformWrapper
              defaultScale={1}
              defaultPositionX={0}
              defaultPositionY={0}
              options={{
                limitToBounds: false,
                minScale: 0.5,
                maxScale: 1,
              }}
              onZoomChange={handleZoomChange}
              onPanningChange={handlePanChange}
            >
              <TransformComponent>
                <img
                  ref={imgRef}
                  src={src}
                  alt="file"
                  style={{
                    transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                    transformOrigin: "0 0",
                    maxWidth: "85vw",
                    maxHeight: "85vh",
                    objectFit: "cover",
                  }}
                />
              </TransformComponent>
            </TransformWrapper>
          ) : src && type === "video" ? (
            <video
              src={src}
              controls
              style={{
                maxHeight: "550px",
                maxWidth: "700px",
              }}
            />
          ) : (
            <p>No hay archivo para mostrar</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPreviewMedia;
